import { Component, h, Prop, State } from '@stencil/core';
import { FormRenderProps, FormValues } from '../../stencil-form/declarations';
import InputField from '../../stencil-form/InputField';
import { store } from '../../../redux/store';
import { fetchGeoCode } from '../../../redux/actions';
import { Unsubscribe } from '@stencil/redux';
import { debounce } from '../../../utils/utils';

@Component({
  tag: 'rtr-address-autocomplete',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RtrAddressAutocomplete {
  @Prop() name: string;
  @Prop() label: string;
  @State() typedAddress: string;
  @State() addressHint: string;
  @State() addressInInput: string;
  @State() openAddressHint: boolean;
  @State() waitingForCalculation: boolean;
  @Prop() formProps: FormRenderProps<FormValues>;
  @Prop() validate = {};

  inputRef: HTMLInputElement;

  fetchGeoCode!: typeof fetchGeoCode;
  unsubscribe!: Unsubscribe;

  componentWillLoad() {
    store.mapDispatchToProps(this, {
      fetchGeoCode,
    });
  }

  debounceFetchGeoCode = debounce((address: string) => {
    this.fetchGeoCode(
      address,
      data => {
        this.addressHint = data.placeName;
        this.openAddressHint = true;
        this.waitingForCalculation = false;
      },
      () => {
        this.waitingForCalculation = false;
      });
  }, 300);

  handleAddressInput = (typedAddress: string) => {
    this.typedAddress = typedAddress;
    if (this.typedAddress.length > 4) {
      this.waitingForCalculation = true;
      this.debounceFetchGeoCode(typedAddress);
    } else {
      this.openAddressHint = false;
    }
  };

  handleHintClick = () => {
    this.typedAddress = this.addressHint;
    this.openAddressHint = false;

    // trigger real input value update
    this.inputRef.value = this.addressHint;
    const event = new Event('input', { bubbles: true });
    this.inputRef.dispatchEvent(event);
  };


  render() {
    return (
      <div>
        <InputField
          {...this.formProps}
          type='text'
          name={this.name}
          label={this.label}
          value={this.typedAddress}
          onInput={(e) => {
            this.handleAddressInput(e.target.value);
          }}
          inputRef={(el: HTMLInputElement) => this.inputRef = el}
          validate={this.validate}
        />

        {this.openAddressHint && this.addressHint && this.typedAddress !== this.addressHint && (
          <div class='AddressHintContainer'>
            <div class='AddressHint' onClick={this.handleHintClick}>
              {this.addressHint}
            </div>
          </div>
        )}
      </div>
    );
  }
}
